import { render } from "./SkirmishesItemInformation.vue?vue&type=template&id=244ae9cb"
import script from "./SkirmishesItemInformation.vue?vue&type=script&lang=js"
export * from "./SkirmishesItemInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__